import { styled } from "@theme/stitches.config"

export const Content = styled("div", {
    maxWidth: 900,
    p: {
        mb: "2rem"
    }
})
